function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 24 24"
}, props), React.createElement("path", {
  d: "M11.199 19.617a1 1 0 001.602 0l3.004-4.018A1 1 0 0015.004 14H8.996a1 1 0 00-.801 1.599l3.004 4.018zM11.199 4.401a1 1 0 011.602 0l3.004 4.019a1 1 0 01-.801 1.598H8.996a1 1 0 01-.801-1.598L11.199 4.4z",
  fill: "#666"
})));